import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="shared--flash-messages"
export default class extends Controller {
  static targets = ["message"]

  connect() {
    this.messageTargets.forEach((el, index) => {
      setTimeout(() => {
        el.classList.remove("opacity-0")
        el.classList.add("opacity-100")
      }, index * 150)

      setTimeout(() => {
        this.fadeOut(el)
      }, 5000 + index * 500)
    })
  }

  fadeOut(el) {
    el.classList.remove("opacity-100")
    el.classList.add("opacity-0")

    setTimeout(() => el.remove(), 500)
  }
}
